import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const ReminderEditor = ({ reminders, onChange }) => {
  const addReminder = () => {
    onChange([
      ...reminders,
      { id: Date.now(), minutes: 1, secondsPart: 0, message: '' },
    ]);
  };

  const updateReminder = (id, field, value) => {
    onChange(
      reminders.map((reminder) =>
        reminder.id === id ? { ...reminder, [field]: value } : reminder
      )
    );
  };

  const removeReminder = (id) => {
    onChange(reminders.filter((reminder) => reminder.id !== id));
  };

  return (
    <div className="rounded-3xl border border-[#c9e1f3] bg-[#edf6fc]/80 p-5">
      <div className="mb-4 flex items-start justify-between gap-4">
        <div>
          <h2 className="font-semibold text-[#245b86]">Custom reminders</h2>
          <p className="mt-1 text-sm text-[#5d87a7]">
            Set an exact time such as 1 minute and 30 seconds remaining.
          </p>
        </div>

        <button
          type="button"
          onClick={addReminder}
          className="flex shrink-0 items-center gap-2 rounded-xl bg-[#4a8ccc] px-3 py-2 text-sm font-semibold text-white transition hover:bg-[#397bbd]"
        >
          <SafeIcon icon={FiPlus} />
          Add
        </button>
      </div>

      <div className="space-y-3">
        {reminders.length === 0 && (
          <p className="rounded-2xl border border-dashed border-[#b8d6eb] p-4 text-center text-sm text-[#6c92ae]">
            Add messages for exact times like 1:25 or 0:30 remaining.
          </p>
        )}

        {reminders.map((reminder) => (
          <div
            key={reminder.id}
            className="flex flex-col gap-3 rounded-2xl bg-white p-3 sm:flex-row sm:items-center"
          >
            <span className="text-sm font-medium text-[#376b92]">At</span>

            <label className="flex items-center gap-2 text-sm text-[#376b92]">
              <input
                type="number"
                min="0"
                max="180"
                value={reminder.minutes ?? 0}
                onChange={(event) =>
                  updateReminder(
                    reminder.id,
                    'minutes',
                    Math.max(0, Number(event.target.value) || 0)
                  )
                }
                className="w-20 rounded-xl border-2 border-[#c9e1f3] px-3 py-2 text-center text-[#245b86] outline-none focus:border-[#4a8ccc]"
              />
              min
            </label>

            <label className="flex items-center gap-2 text-sm text-[#376b92]">
              <input
                type="number"
                min="0"
                max="59"
                value={reminder.secondsPart ?? 0}
                onChange={(event) =>
                  updateReminder(
                    reminder.id,
                    'secondsPart',
                    Math.min(59, Math.max(0, Number(event.target.value) || 0))
                  )
                }
                className="w-20 rounded-xl border-2 border-[#c9e1f3] px-3 py-2 text-center text-[#245b86] outline-none focus:border-[#4a8ccc]"
              />
              sec
            </label>

            <input
              type="text"
              value={reminder.message}
              onChange={(event) =>
                updateReminder(reminder.id, 'message', event.target.value)
              }
              placeholder="Keep it up!"
              className="min-w-0 flex-1 rounded-xl border-2 border-[#c9e1f3] px-3 py-2 text-[#245b86] outline-none placeholder:text-[#9db8ca] focus:border-[#4a8ccc]"
            />

            <button
              type="button"
              onClick={() => removeReminder(reminder.id)}
              className="self-end rounded-xl p-2 text-[#d47b7b] transition hover:bg-[#fff1f1] sm:self-auto"
              title="Remove reminder"
            >
              <SafeIcon icon={FiTrash2} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReminderEditor;